module.exports = __webpack_public_path__ + "static/img/Testimonial1.817f1bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Testimonial1.png
// module id = XiGS
// module chunks = 36